<template>
  <div class="overflow-hidden">
    <a
      class="btn btn-sm btn-block btn-info text-white"
      data-target="#modalAddMinMax"
      data-toggle="modal"
      href="#"
    >
      <i class="os-icon os-icon-ui-22"></i>
      <span>Modificar o Asignar Tienda</span>
    </a>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddMinMax"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div
          class="modal-content color-scheme-dark"
          style="width: 100%; max-width: 100%"
        >
          <div class="modal-header faded smaller">
            <h5 class="text-success modal-title">Configuraciones de tiendas</h5>
            <br />
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="editedCount > 0" class="d-flex justify-content-end mb-2" style="gap: 8px">
              <div class="d-flex align-items-center mr-auto">
                <span class="badge badge-warning">
                  <i class="fas fa-pencil-alt mr-1"></i>
                  {{ editedCount }} cambio{{ editedCount > 1 ? 's' : '' }} pendiente{{ editedCount > 1 ? 's' : '' }} de guardar
                </span>
              </div>
              <button class="btn btn-warning  btn-sm" :disabled="guardando" @click="descartarCambios">
                <i class="fas fa-undo mr-1"></i>Descartar
              </button>
              <button class="btn btn-success btn-sm" :disabled="guardando" @click="guardarCambios">
                <span v-if="guardando" class="spinner-border spinner-border-sm mr-1" role="status"></span>
                <i v-else class="fas fa-save mr-1"></i>
                {{ guardando ? 'Guardando...' : 'Guardar ' + editedCount + ' cambio' + (editedCount > 1 ? 's' : '') }}
              </button>
            </div>
            <div class="element-wrapper">
              <div style="--table-sticky-top: 0px;">
                <!-- <div v-if="!tiendasCargadas" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Cargando...</span>
                  </div>
                  <p class="mb-0 mt-2 text-muted small">Cargando configuraci&oacute;n...</p>
                </div> -->
                <ProductoTiendaConfigTable
                  v-if="config_producto_en_tiendas.length > 0"
                  ref="configTable"
                  :configuraciones_producto_tienda="config_producto_en_tiendas"
                  :allowed-units="allowedUnits"
                  max-height="75vh"
                  @edited-count-change="c => editedCount = c"
                  @refresh-existencia="onRefreshExistencia"
                  @error-existencia="msg => Notifications.alert.error('Error', msg)"
                >
                  <template #columns-start>
                    <th style="min-width:50px" class="align-middle">ID</th>
                  </template>
                  <template #cells-start="{ item }">
                    <td class="align-middle small font-weight-bold">
                      {{ item.codigo_tienda }}
                      <span v-if="!item.activo && !item.deshabilitado" class="badge badge-danger ml-1">inactivo</span>
                      <small v-if="item.errorInactivacion && !item.activo" class="d-block text-danger font-weight-bold" :title="item.errorInactivacion">{{ item.errorInactivacion }}</small>
                    </td>
                  </template>
                </ProductoTiendaConfigTable>
                <small style="color: #ff9b00" class="font-weight-bold"
                  >Tomar en cuenta lo siguiente:
                  <br />
                  <i style="color: #00fff3" class="fas fa-info-circle"></i>
                  Cualquier modificaci&oacute;n realizada en la configuraci&oacute;n esta bajo
                  su propia responsabilidad.
                  <br />
                  <i style="color: #00fff3" class="fas fa-info-circle"></i>
                  Recuerde no modificar datos que no correspondan a su tienda de
                  trabajo, cualquier modificaci&oacute;n realizada quedara registrada
                  con su informaci&oacute;n usuario.</small
                >
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-success"
              @click="agregarTiendaModal()"
              type="button"
            >
              Nueva Tienda
            </button>
            <button
              class="btn btn-warning"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Agregar Tienda Modal -->
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddTienda"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content color-scheme-dark">
          <div class="modal-header faded smaller">
            <h5 class="text-success modal-title">Agregar Producto a Tienda</h5>
            <br />
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="font-weight-bold">Tienda</label>
              <select
                class="form-control"
                v-model="nuevaTiendaData.tienda"
              >
                <option value="" disabled>Seleccione una tienda</option>
                <option
                  v-for="store in tiendasNoAsignadas"
                  :key="store.id || store.codigo"
                  :value="store.codigo"
                >
                  {{ store.codigo }} - {{ store.nombre }}
                </option>
              </select>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.activo" />
                    Activo
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.sol_auto" />
                    Sol. Auto
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.permitir_ajustes" />
                    Ajustes
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.permitir_compras" />
                    Compras
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.permitir_ventas" />
                    Ventas
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.permitir_ingresos_t" />
                    Ingresos
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.permitir_salidas_t" />
                    Salidas
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.permitir_devoluciones" />
                    Devoluciones
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.compra_local" />
                    Compra Local
                  </label>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-4">
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" v-model="nuevaTiendaData.permitir_requerimiento_manual" />
                    Req. Manual
                  </label>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-4">
                <label>M&iacute;nimo</label>
                <input
                  class="form-control"
                  type="number"
                  min="0"
                  v-model.number="nuevaTiendaData.minimo"
                />
              </div>
              <div class="col-4">
                <label>M&aacute;ximo</label>
                <input
                  class="form-control"
                  type="number"
                  min="0"
                  v-model.number="nuevaTiendaData.maximo"
                />
              </div>
              <div class="col-4">
                <label>U.M. Traslado</label>
                <select
                  class="form-control"
                  v-model="nuevaTiendaData.unidad_medida_solicitud"
                  :disabled="allowedUnits.length === 0"
                >
                  <option value="">&mdash; Sin U.M. &mdash;</option>
                  <option
                    v-for="unit in allowedUnits"
                    :key="unit.unidad_medida"
                    :value="unit.unidad_medida"
                  >
                    {{ (unit.unidad_medida_obj && unit.unidad_medida_obj.nombre) || '' }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-success"
              @click="confirmarAgregarTienda()"
              type="button"
              :disabled="!nuevaTiendaData.tienda || guardando"
            >
              <span v-if="guardando" class="spinner-border spinner-border-sm mr-1" role="status"></span>
              Agregar tienda
            </button>
            <button
              class="btn btn-warning"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import ProductoTiendaConfigTable, { CAMPOS_TRACKED } from "@/components/cat/producto-tienda/ProductoTiendaConfigTable.vue";

const VALORES_POR_DEFECTO = {
  activo: true,
  sol_auto: false,
  permitir_ajustes: false,
  permitir_compras: false,
  permitir_ventas: false,
  permitir_ingresos_t: false,
  permitir_salidas_t: false,
  permitir_devoluciones: false,
  compra_local: false,
  permitir_requerimiento_manual: false,
  minimo: 0,
  maximo: 0,
  unidad_medida_solicitud: null,
};

export default {
  components: {
    ProductoTiendaConfigTable,
  },
  data() {
    return {
      config_producto_en_tiendas: [],
      allowedUnits: [],
      editedCount: 0,
      guardando: false,
      tiendasCargadas: false,
      nuevaTiendaData: { ...VALORES_POR_DEFECTO, tienda: "" },
    };
  },
  props: {
    current: {
      type: Object,
      required: true,
    },
    filtrartienda: {
      type: String,
      required: false,
      default: null,
    },
    tiendas: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    tiendasNoAsignadas() {
      let self = this;
      const asignadas = new Set(
        (self.current.productotienda_set || []).map(pt => pt.tienda)
      );
      return (self.tiendas || []).filter(t => !asignadas.has(t.codigo));
    },
  },
  watch: {
    tiendas: {
      handler() { this.generarConfiguracionesTienda(); },
      immediate: true,
    },
    "current.productotienda_set": {
      handler() { this.generarConfiguracionesTienda(); },
      deep: true,
    },
  },
  mounted() {
    this.cargarUnidadesMedida();
  },
  methods: {
    cargarUnidadesMedida() {
      let self = this;
      if (!self.current.sku) return;
      DynamicService.fetch("cat", "producto-unidad_medida", {
        producto: self.current.sku,
        limit: 1000,
      })
        .then((response) => {
          self.allowedUnits = (response.data && response.data.results) ? response.data.results : [];
        })
        .catch(() => {
          self.allowedUnits = [];
        });
    },
    generarConfiguracionesTienda() {
      let self = this;
      const productoTiendas = self.current.productotienda_set || [];
      const sku = self.current.sku;

      if (!sku || !productoTiendas.length) {
        self.config_producto_en_tiendas = [];
        self.tiendasCargadas = true;
        return;
      }

      self.config_producto_en_tiendas = productoTiendas.map(pt => {
        const item = {
          id: pt.id,
          codigo_tienda: pt.tienda,
          nombreTienda: pt.nombre_tienda || pt.tienda,
          activo: pt.activo !== false,
          deshabilitado: false,
          tienda: pt.tienda,
          existencia: pt.existencia || 0,
          ...VALORES_POR_DEFECTO,
          ...pt,
        };

        item.originalValue = JSON.parse(JSON.stringify(
          CAMPOS_TRACKED.reduce(function(acc, key) {
            acc[key] = item[key];
            return acc;
          }, {})
        ));

        return item;
      });

      self.tiendasCargadas = true;
    },
    guardarCambios() {
      let self = this;
      if (!self.$refs.configTable) return;

      const registros = self.$refs.configTable.getModifiedPayloads();
      if (!registros.length) return;

      self.guardando = true;

      DynamicService.postActionList(
        "cat",
        "producto-tienda",
        "updates_fields_or_creates_productotienda",
        { registros_modificados: registros }
      )
        .then(function(response) {
          const data = response.data;
          const errors = data.errores && data.errores.length > 0;
          const success = (data.actualizados && data.actualizados.length > 0) || (data.creados && data.creados.length > 0);
          if (errors) {
            self._manejarErroresGuardado({ response: { data } });
          }
         if (success) {
           if (errors) {
             const clavesErrores = data.errores.map(function(f) { return f.producto + '-' + f.tienda; })
             self.$refs.configTable.resetSavedItemsExcluyendo(clavesErrores)
           } else {
             self.$refs.configTable.resetSavedItems()
           }
           if (errors) {
             Notifications.alert.warning(
               "Parcial",
               "Se guardaron " + data.actualizados.length + " cambio(s), pero " + data.errores.length + " no se pudieron actualizar."
             );
           } else {
             Notifications.alert.success("Exito", "Cambios guardados exitosamente.");
           }
         } else if (!errors) {
           Notifications.alert.error(
             "Error",
             "Error al guardar. Intente nuevamente."
           );
         }
       })
       .catch(function(error) {
         self._manejarErroresGuardado(error);
         Notifications.alert.error(
           "Error",
           (error.response && error.response.data && error.response.data.detail) || "Error al guardar. Intente nuevamente."
         );
       })
       .finally(function() {
         self.guardando = false;
       });
     },
     _manejarErroresGuardado(error) {
       let self = this;
       const errores = (error && error.response && error.response.data && error.response.data.errores) || error.errores || [];
       if (!errores.length) {
         Notifications.alert.error(
           "Error",
           (error.response && error.response.data && error.response.data.detail) || "Error al guardar. Intente nuevamente."
         );
         return;
       }
       const erroresPorRegistro = {};
       let clavesCompletas = true;
       errores.forEach(function(f) {
         if (f.producto && f.tienda) {
           erroresPorRegistro[f.producto + "-" + f.tienda] = f.error;
         } else {
           clavesCompletas = false;
         }
       });
       if (clavesCompletas) {
         self.$refs.configTable.marcarErroresInactivacion(erroresPorRegistro);
       } else {
         Notifications.alert.error(
           "Error",
           (error.response && error.response.data && error.response.data.detail) || "Error al guardar. Intente nuevamente."
         );
         return;
       }
     },
    descartarCambios() {
      if (this.$refs.configTable) {
        this.$refs.configTable.descartarTodosLosCambios();
      }
    },
    agregarTiendaModal() {
      this.nuevaTiendaData = { ...VALORES_POR_DEFECTO, tienda: "" };
      $("#modalAddMinMax").modal("hide");
      $("#modalAddTienda").modal("show");
    },
    confirmarAgregarTienda() {
      let self = this;
      if (!self.nuevaTiendaData.tienda) return;

      const config = {};
      const tiendaId = self.nuevaTiendaData.tienda;

      CAMPOS_TRACKED.forEach(function(key) {
        if (key in self.nuevaTiendaData) {
          config[key] = self.nuevaTiendaData[key];
        }
      });

      const payload = {
        registros_modificados: [{
          id: self.current.sku + "-" + tiendaId,
          producto_id: self.current.sku,
          tienda_id: tiendaId,
          campos_modificados: config,
        }]
      };

      self.guardando = true;

      DynamicService.postActionList(
        "cat",
        "producto-tienda",
        "updates_fields_or_creates_productotienda",
        payload
      )
        .then(function() {
          Notifications.alert.success(
            "Asignar producto a tienda",
            "Realizado correctamente"
          );
          $("#modalAddTienda").modal("hide");
          self.$emit("cerrandomodal");
        })
        .catch(function(error) {
          Notifications.alert.error(
            "Asignar producto a tienda",
            (error.response && error.response.data && error.response.data.detail) || "Error al asignar tienda"
          );
        })
        .finally(function() {
          self.guardando = false;
        });
    },
    onRefreshExistencia() {
      let self = this;
      const sku = self.current.sku;
      if (!sku) return;
      DynamicService.getActionList(
        'cat', 'producto-tienda',
        'obtener_producto_tiendas_detalle_x_sku',
        { sku: sku }
      )
        .then(function(response) {
          const productoTiendas = response.data && response.data.results ? response.data.results : response.data || [];
          const ptMap = new Map(productoTiendas.map(function(pt) { return [pt.tienda, pt]; }));
          self.config_producto_en_tiendas.forEach(function(item) {
            const pt = ptMap.get(item.tienda);
            if (pt) {
              self.$set(item, 'existencia', pt.existencia || 0);
            }
          });
        })
        .catch(function() {
          Notifications.alert.error('Error', 'No se pudo actualizar la existencia.');
        });
    },
  },
};
</script>

<style>
</style>
